import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { useDataLayerPush } from '@/app/_utils/use-datalayer-push';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
import { elementTrackingId } from '../contants';
interface Props extends CarouselItemViewModel, IsLoadingLazyProps, DataLayerProps {}
function TileItem({
  id,
  link,
  desktopImageUrl,
  mobileImageUrl,
  title,
  isLazy,
  sortKey,
  componentId,
  index
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const pushToDataLayer = useDataLayerPush();
  const handleClick = () => {
    pushToDataLayer({
      event: elementTrackingId,
      elementType: ComponentType.MobileCarouselDesktopTile,
      elementIndex: index || 0,
      itemID: id || '',
      elementName: sortKey,
      destinationUrl: link || '',
      componentId,
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.MobileCarouselDesktopTile,
      banner_name: sortKey ?? '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: componentId ?? '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  return <AppNextLink href={link || ''} aria-label={title || ''} prefetch={false} className='relative overflow-hidden rounded' onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="TileItem" data-sentry-source-file="tile-item.tsx">
            <picture className='flex' data-sentry-element="picture" data-sentry-source-file="tile-item.tsx">
                <source media='(min-width: 1024px)' srcSet={desktopImageUrl || ''} />

                <LazyImage src={mobileImageUrl || ''} alt={title || ''} className='w-full' loaderClassName='h-40' isLazy={isLazy} height={160} data-sentry-element="LazyImage" data-sentry-source-file="tile-item.tsx" />
            </picture>
        </AppNextLink>;
}
export default TileItem;